import Financeurs from './components/Financeurs';
import Form from './components/Form'

function App() {

  
  let date = new Date().toISOString().slice(0, 10)
  const expirationDate = new Date('2024-09-30T00:00:00Z').toISOString().slice(0, 10)

  
  return (
    <div className="App">
    
    {date > expirationDate ? 
       
       <>
       <div className="expirationDate">
        <h2>Ce formulaire est maintenant clôturé</h2>
        <div className="contact">
              <h4>Pour plus d'informations :</h4>
              <h3>Mathieu VIVOT</h3>
              <h4>Commercialisation du forum AGORA JOBS</h4>
              <h4><a href="tel:0384545456">03.84.54.54.56</a></h4>
              <h4><a href="mailto:mvivot@belfort.cci.fr">mvivot@belfort.cci.fr</a></h4>
            </div>
        </div>
        <Financeurs />
       </>

       :
    
       <Form />
        
    }
  
    </div>
  );
}

export default App;
